import React from 'react';
import { TaskManager } from '../../../helpers/form.new/task.manager';

type TopFormAdditionalData = {
    purpose?: string;
};

type Context = {
    topFormAdditionalData: TopFormAdditionalData;
    setTopFormAdditionalData: (data: TopFormAdditionalData) => void;
    showLanding: boolean;

    taskManager: TaskManager;
};

export const CardsContext = React.createContext<Context>({} as Context);
